<!-- <main class="container-login">
    <section class="login">
        <article class="article-login">

            <div class="card" style="width: 250px">
                <h4 class="card-header">Registrar</h4>
                <div class="card-body">
                    <div class="registro-container">
                        <a class="link-rol" [routerLink]="['/registrar/medico']">
                            <i class="fas fa-user-md"></i> Médico
                        </a>
                        <a class="link-rol" [routerLink]="['/registrar/enfermera']">
                            <i class="fas fa-user-nurse"></i> Enfermera
                        </a>
                        <a class="link-rol" [routerLink]="['/registrar/supervisor']">
                            <i class="fas fa-user-nurse"></i> Supervisor
                        </a>

                    </div>
                    <a class="card-header" [routerLink]="['/']">regresar</a>
                </div>

            </div>

        </article>
        <article class="article-img">
            <div class="container-img"></div>
        </article>
    </section>
</main>
<p-toast></p-toast> -->

<main class="container-login">
    <section class="login">
        <article class="article-login">
            <div class="card">
                <div class="card-header">
                    <h2>Registro de Médico</h2>
                    
                </div>
                
                <div class="card-body">
                    <div class="registro-container">
                        <a class="link-rol" [routerLink]="['/registrar/medico']">
                            <div class="icon-circle">
                                <i class="fas fa-user-md"></i>
                            </div>
                            <div class="rol-info">
                                <span class="rol-titulo">Médico</span>
                                <span class="rol-descripcion">Acceso a casos clínicos</span>
                            </div>
                            <i class="fas fa-chevron-right arrow"></i>
                        </a>
<!--
                         <a class="link-rol" [routerLink]="['/registrar/enfermera']">
                            <div class="icon-circle">
                                <i class="fas fa-user-nurse"></i>
                            </div>
                            <div class="rol-info">
                                <span class="rol-titulo">Enfermera</span>
                                <span class="rol-descripcion">Gestión de pacientes</span>
                            </div>
                            <i class="fas fa-chevron-right arrow"></i>
                        </a>

                        <a class="link-rol" [routerLink]="['/registrar/supervisor']">
                            <div class="icon-circle">
                                <i class="fas fa-user-tie"></i>
                            </div>
                            <div class="rol-info">
                                <span class="rol-titulo">Supervisor</span>
                                <span class="rol-descripcion">Control y monitoreo</span>
                            </div>
                            <i class="fas fa-chevron-right arrow"></i>
                        </a>
-->
                       
                    </div>

                    <div class="back-link">
                        <a [routerLink]="['/']">
                            <i class="fas fa-arrow-left"></i>
                            Volver a inicio
                        </a>
                    </div>
                </div>
            </div>
        </article>

        <article class="article-img">
            <div class="container-img">
                <div class="img-overlay">
                    <h2>Únete a Casos Clínicos</h2>
                    <p>Regístrate y comienza a gestionar tus casos clínicos de manera eficiente</p>
                </div>
            </div>
        </article>
    </section>
</main>
<p-toast></p-toast>